import React from "react";

import { OverflowTooltip } from "components";
import { Application, TableCellProp } from "types";

import styles from "../applicationList.module.scss";

const applicationIdColumn = () => ({
	Header: "App ID",
	accessor: "applicationNumber",
	classNameCell: styles.appIdCol,
	classNameHeader: styles.appIdCol,
	disableSortBy: true,
	Cell: ({ row: { original } }: TableCellProp<Application>) => {
		return (
			<div
				className={
					original?.is_warning
						? "cell-with-pended-sign show"
						: "cell-with-pended-sign"
				}
			>
				<OverflowTooltip onlyOnLaptop title={original?.number}>
					{original?.number}
				</OverflowTooltip>
			</div>
		);
	},
});

export default applicationIdColumn;
